/* tslint:disable */
/* eslint-disable */
/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const DriverRegistrationLogCreatedVia = {
        NEW_FLEET_REGISTRATION: 'new_fleet_registration',
        FLEET_RELOCATION: 'fleet_relocation',
        FLEET_RELOCATION_SUBSTITUTION: 'fleet_relocation_substitution',
        NEW_PRIVATE_REGISTRATION: 'new_private_registration'
} as const;
export type DriverRegistrationLogCreatedVia = typeof DriverRegistrationLogCreatedVia[keyof typeof DriverRegistrationLogCreatedVia];

